<template>
  <div class="h-screen w-screen flex justify-center items-center">
    <div
      class="flex h-1/3 w-1/3 p-4 border-2 border-solid shadow-xl md:flex-col lg:flex-row"
      :class="'border-' + options[pageType].className"
    >
      <div class="flex-1 flex justify-center items-center text-8xl p-8" :class="'text-' + options[pageType].className">
        {{ pageType }}
      </div>
      <div class="flex flex-col flex-3 justify-around">
        <div>
          <img :src="logoSrc" alt="logo" width="172" />
        </div>
        <div class="flex"><h2 class="text-theme">调研工厂温馨提醒您：</h2></div>
        <div>{{ options[pageType].message }}</div>
        <div>
          <el-button size="medium" @click="rr">返回</el-button>
          <el-button type="primary" size="medium" v-if="pageType !== '500'" @click="rl">问卷列表</el-button>
          <el-button type="primary" size="medium" v-else @click="rlogin">重新登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import { logo } from '@/assets/js/logo'
import { getDomain } from '@/assets/js/config/env'

export default {
  name: 'ErrorPage',
  props: {
    pageType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      options: {
        [401]: {
          className: 'yellow-theme',
          message: '您无权限访问，请返回',
          opt: ['return']
        },
        [404]: {
          className: 'theme',
          message: '当前页面无法找到',
          opt: ['return']
        },
        [500]: {
          className: 'danger',
          message: '内部错误，请稍后重试',
          opt: ['return']
        }
      },
      logoSrc: logo().logoSrc
    }
  },
  methods: {
    rr() {
      window.history.go(-1)
    },
    rl() {
      this.$router.push('/')
    },
    rlogin() {
      this.$store.dispatch('LogOut').then(() => {
        window.location.href = getDomain() + '/newlogin?companyid=' + GlobalConfig.getCompanyId()
      })
    }
  }
}
</script>
